/**
 * Universal Floating Labels — Gravity Forms + Elementor Form widget
 * =================================================================
 * Places the field label on top of the input; on focus (or when the
 * field has a value) the label slides up above the input.
 *
 * Works with regular and AJAX-rendered Gravity Forms (gform_post_render)
 * and with Elementor (Pro) Form widgets. Only simple single-input fields
 * are enhanced (text, email, phone, number, url, password, textarea).
 * Complex fields (name, address, checkbox, radio, date pickers, selects,
 * file uploads) keep the default static label.
 */

(function () {
	'use strict';

	const FLOATING_CLASS = 'gfield--floating';
	const FILLED_CLASS = 'is-filled';

	const INPUT_SELECTOR = [
		// Gravity Forms
		'.ginput_container_text input',
		'.ginput_container_email input',
		'.ginput_container_phone input',
		'.ginput_container_number input',
		'.ginput_container_website input',
		'.ginput_container_password input',
		'.ginput_container_textarea textarea',
		// Elementor Form widget
		'.elementor-field-group input.elementor-field-textual[type="text"]',
		'.elementor-field-group input.elementor-field-textual[type="email"]',
		'.elementor-field-group input.elementor-field-textual[type="tel"]',
		'.elementor-field-group input.elementor-field-textual[type="number"]',
		'.elementor-field-group input.elementor-field-textual[type="url"]',
		'.elementor-field-group input.elementor-field-textual[type="password"]',
		'.elementor-field-group textarea.elementor-field-textual',
	].join(', ');

	const FIELD_SELECTOR = '.gform_wrapper .gfield, .elementor-form .elementor-field-group';
	const LABEL_SELECTOR = '.gfield_label, .elementor-field-label';

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	function init() {
		enhanceForms(document);

		// Re-run after Gravity Forms AJAX (re)render / multi-page navigation
		document.addEventListener('gform/post_render', function (e) {
			enhanceForms(e.target || document);
		});

		// Legacy jQuery events fired by Gravity Forms / Elementor popups
		// (only if jQuery happens to be present)
		if (window.jQuery) {
			window.jQuery(document).on('gform_post_render', function () {
				enhanceForms(document);
			});

			// Elementor popup forms are rendered when the popup opens
			window.jQuery(document).on('elementor/popup/show', function () {
				enhanceForms(document);
			});
		}

		// Event delegation: keep filled state in sync
		document.addEventListener('input', handleValueChange);
		document.addEventListener('change', handleValueChange);
	}

	/**
	 * Find eligible form fields (Gravity Forms + Elementor) and enable
	 * floating labels.
	 */
	function enhanceForms(root) {
		const fields = root.querySelectorAll(FIELD_SELECTOR);

		fields.forEach(function (field) {
			const input = field.querySelector(INPUT_SELECTOR);
			const label = field.querySelector(LABEL_SELECTOR);

			if (!input || !label || field.classList.contains(FLOATING_CLASS)) {
				return;
			}

			field.classList.add(FLOATING_CLASS);

			// A placeholder conflicts with an overlaying label — remove it
			input.removeAttribute('placeholder');

			updateFilledState(field, input);
		});
	}

	/**
	 * Sync the filled state when an enhanced input changes.
	 */
	function handleValueChange(e) {
		const input = e.target;

		if (!input.matches || !input.matches(INPUT_SELECTOR)) {
			return;
		}

		const field = input.closest('.' + FLOATING_CLASS);

		if (field) {
			updateFilledState(field, input);
		}
	}

	/**
	 * Toggle the is-filled class based on the input value.
	 */
	function updateFilledState(field, input) {
		field.classList.toggle(FILLED_CLASS, input.value.trim() !== '');
	}
})();

